module.exports = __webpack_public_path__ + "img/USDC.02a7fe7f.svg";